import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import identificationTypes from "../../../data/identificationTypes.json";
import taxResponsibilities from "../../../data/taxResponsibilities.json";

import { MultipleSelect } from '../../../components/others/MultipleSelect';

export const CreateCompany = ({
    values,
    errorInputs,
    isEdit,
    countries,
    states,
    cities,
    handleInputChange,
    handleDirectInputChange,
    handleChangeCountryState,
    t
}) => {

    const handleSelectObligation = (event) => {
        const { target: { value }, } = event;
        const formattedValue = Array.isArray(value) ? value : (typeof value === 'string' ? value.split(',') : []);
        handleDirectInputChange('supplier_tax_level_code', formattedValue);
    };

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography variant="h6">{t("company.companyInfo")}</Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="id_number"
                        label={t("commonFields.idNumber")}
                        value={values.id_number || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.id_number?.isError}
                        helperText={errorInputs.id_number?.messageError}
                        required
                        disabled={isEdit}
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="supplier_digit"
                        label={t("commonFields.verificationDigit")}
                        value={values.supplier_digit || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.supplier_digit?.isError}
                        helperText={errorInputs.supplier_digit?.messageError}
                        required={values?.supplier_tax_id === '31'}
                        disabled
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="name"
                        label={t("commonFields.businessName")}
                        value={values.name || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.name?.isError}
                        helperText={errorInputs.name?.messageError}
                        required
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl
                        fullWidth
                        size="small"
                        error={Boolean(errorInputs.supplier_tax_id?.isError)}
                        required
                    >
                        <InputLabel>{t("commonFields.identificationType")}</InputLabel>
                        <Select
                            label={t("commonFields.identificationType")}
                            name="supplier_tax_id"
                            value={values.supplier_tax_id}
                            onChange={handleInputChange}
                        >
                            {identificationTypes.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                        {errorInputs.supplier_tax_id?.isError && (
                            <FormHelperText>{errorInputs.supplier_tax_id.messageError}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl
                        fullWidth size="small"
                        error={!!errorInputs.supplier_additional_account_id?.isError}
                        required>
                        <InputLabel>Supplier Additional Account ID</InputLabel>
                        <Select
                            label={t("commonFields.regimeType")}
                            name="supplier_additional_account_id"
                            value={values.supplier_additional_account_id}
                            onChange={handleInputChange}
                        >
                            <MenuItem value="1">Jurídico</MenuItem>
                            <MenuItem value="2">Natural</MenuItem>
                        </Select>
                        {errorInputs.supplier_additional_account_id?.isError && (
                            <FormHelperText>{errorInputs.supplier_additional_account_id.messageError}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>


                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl
                        fullWidth size="small"
                        error={!!errorInputs.supplier_tax_scheme?.isError}
                        required>
                        <InputLabel>{t("commonFields.taxType")}</InputLabel>
                        <Select
                            label={t("commonFields.taxType")}
                            name="supplier_tax_scheme"
                            value={values.supplier_tax_scheme}
                            onChange={handleInputChange}
                        >
                            <MenuItem value="01">IVA</MenuItem>
                            <MenuItem value="04">INC</MenuItem>
                            <MenuItem value="ZA">IVA e INC</MenuItem>
                            <MenuItem value="ZZ">No aplica</MenuItem>
                        </Select>
                        {errorInputs.supplier_tax_scheme?.isError && (
                            <FormHelperText>{errorInputs.supplier_tax_scheme.messageError}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="email"
                        type='email'
                        label={t("commonFields.email")}
                        value={values.email || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.email?.isError}
                        helperText={errorInputs.email?.messageError}
                        required
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }} >
                    <MultipleSelect
                        data={taxResponsibilities}
                        values={Array.isArray(values.supplier_tax_level_code) ? values.supplier_tax_level_code : []}
                        handleChange={handleSelectObligation}
                        label={t("commonFields.obligations")}
                        error={!!errorInputs.supplier_tax_level_code?.isError}
                        errorText={errorInputs.supplier_tax_level_code?.messageError}
                    />
                </Grid>
            </Grid>

            <DividerGradient />

            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel>{t("commonFields.location.country")}</InputLabel>
                        <Select name="country_id" value={values.country_id} onChange={(e) => handleChangeCountryState(e, 'STATE')}>
                            {countries.map((option) => (
                                <MenuItem key={option.id_country} value={option.code}>{option.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    {values.country_id === 'CO' ? (
                        <FormControl fullWidth size="small">
                            <InputLabel>{t("commonFields.location.state")}</InputLabel>
                            <Select name="state_id" value={values.state_id} onChange={(e) => handleChangeCountryState(e, 'CITY')}>
                                {states.map((option) => (
                                    <MenuItem key={option.id_state} value={option.code}>{option.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <TextField
                            fullWidth
                            size="small"
                            name="state_id"
                            label={t("commonFields.location.state")}
                            value={values.state_id}
                            onChange={handleInputChange}
                        />
                    )}
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    {values.country_id === 'CO' ? (
                        <FormControl fullWidth size="small">
                            <InputLabel>{t("commonFields.location.city")}</InputLabel>
                            <Select name="city_id" value={values.city_id} onChange={handleInputChange}>
                                {cities.map((option) => (
                                    <MenuItem key={option.code} value={option.code}>{option.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <TextField
                            fullWidth
                            size="small"
                            name="city_id"
                            label={t("commonFields.location.city")}
                            value={values.city_id}
                            onChange={handleInputChange}
                        />
                    )}
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth size="small" name="address" label="Dirección"
                        value={values.address} onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth size="small" name="phone" label="Teléfono" type="number"
                        value={values.phone} onChange={handleInputChange}
                    />
                </Grid>
            </Grid>

            <DividerGradient />

            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography variant="h6">{t("company.softwareInfo")}</Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="software_id"
                        label="Software ID"
                        value={values.software_id || ''}
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="software_pin"
                        label="Software PIN"
                        value={values.software_pin || ''}
                        onChange={handleInputChange}
                    />
                </Grid>
            </Grid>

            <DividerGradient />

            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography variant="h6">{t("company.legalRepresentativeInfo")}</Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="person_id"
                        label={t("commonFields.idNumber")}
                        value={values.person_id || ''}
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="person_first_name"
                        label={t("commonFields.name")}
                        value={values.person_first_name || ''}
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="person_family_name"
                        label={t("commonFields.lastName")}
                        value={values.person_family_name || ''}
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="person_title"
                        label={t("commonFields.legalRepresentative.companyPosition")}
                        value={values.person_title || ''}
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        name="person_departament"
                        label={t("commonFields.legalRepresentative.workArea")}
                        value={values.person_departament || ''}
                        onChange={handleInputChange}
                    />
                </Grid>
            </Grid>
        </>
    );
};